module.exports = __webpack_public_path__ + "static/media/test31.1f38dc8c.jpeg";